import './index.scss';

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { LocalSessionKey } from '../../burger-king-lib/constants/app-constants';
import { SessionStorage } from '../../burger-king-lib/utils/storage.web';
import { getMinusImage, getPlusImage } from '../../utils/imageChanges';
import LocationRestriction from '../location-restriction-popover';

class CountButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      noService: false,
      showAlert: false,
      outlet: {}
    };
  }

  componentDidMount = () => {
    const outletId = SessionStorage.get(LocalSessionKey.OUTLET_ID);
    const outletStatus = SessionStorage.get('Store_Status') || {};
    if (outletStatus && outletStatus.status) {
      this.setState({ outlet: outletStatus });
    }
    if (outletId === 32236 || (outletStatus && outletStatus.status)) {
      this.setState({ noService: true });
    }
  };

  showModal = () => {
    this.setState({
      showAlert: true
    });
  };

  closeAlertModal = () => {
    this.setState({ showAlert: false });
  };

  render() {
    const {
      content,
      countClick,
      theme,
      size,
      contentBg,
      customClass,
      disabled,
      data
    } = this.props;
    // console.log(data, ' data1234 ', content);
    const { showAlert, noService, outlet } = this.state;
    const { is_crown_product = false } = data || {};

    return (
      <>
        <button
          type="button"
          className={`count-button ${theme} ${size} ${contentBg} ${customClass} ${disabled &&
            'disabled'}`}
          disabled={disabled}
        >
          {content?.toString() && content?.toString() !== '0' ? (
            <>
              <div
                className={`${
                  disabled
                    ? 'count-button__disabled'
                    : 'count-button__img-wrapper'
                }`}
                // className='count-button__img-wrapper'
                role="presentation"
                onClick={
                  noService ? () => this.showModal() : () => countClick(false)
                }
              >
                <img
                  src={getMinusImage(theme)}
                  alt="minus"
                  className="count-button__leftContent"
                />
              </div>

              <div
                className={`count-button__content ${
                  contentBg ? `bg-${contentBg}` : ''
                }`}
              >
                {content}
              </div>

              <div
                className={`${
                  disabled
                    ? 'count-button__disabled'
                    : 'count-button__img-wrapper'
                }`}
                role="presentation"
                onClick={
                  noService
                    ? () => this.showModal()
                    : () => {
                        if (
                          data?.max === content ||
                          is_crown_product ||
                          data?.is_from_offer
                        ) {
                        } else countClick(true);
                      }
                }
              >
                <img
                  src={getPlusImage(theme)}
                  alt="plus"
                  className="count-button__rightContent"
                  style={{
                    display:
                      data?.max === content ||
                      is_crown_product ||
                      data?.is_from_offer
                        ? 'none'
                        : 'block'
                  }}
                />
              </div>
            </>
          ) : (
            <div
              role="presentation"
              className="count-button__add"
              onClick={
                noService ? () => this.showModal() : () => countClick(true)
              }
            >
              <span>ADD </span>
              <span className="count-button__plus">+</span>
            </div>
          )}
        </button>
        {showAlert && (
          <LocationRestriction
            title={outlet && outlet.title ? outlet.title : 'Sorry!'}
            description={
              outlet && outlet.status
                ? outlet.status
                : 'None of our restaurants are near you. Please try with some other location.'
            }
            okayClick={this.closeAlertModal}
            theme={theme}
          />
        )}
      </>
    );
  }
}

CountButton.propTypes = {
  content: PropTypes.number,
  countClick: PropTypes.func,
  size: PropTypes.string,
  theme: PropTypes.string,
  contentBg: PropTypes.string
};

CountButton.defaultProps = {
  content: 0,
  countClick: () => {},
  theme: '',
  size: '',
  contentBg: ''
};

export default CountButton;
